export default function getPropertyAssignmentValue(targetPropertyName, metadata) {
  const assignment = metadata.properties.find(property => property.targetProperty === targetPropertyName);
  return assignment && assignment.value;
}